/**
 * Gets a random number within the provided range
 * @param min The minimum number
 * @param max The maximum number
 * @returns a value between min and max
 */
export function getRandomNumberInRange(min: number, max: number) {
	return Math.floor(Math.random() * (max - min + 1)) + min
}
